import React, {
  FC,
  useEffect,
  useState,
  useRef,
  Dispatch,
  SetStateAction,
} from "react";
import {
  Box,
  View,
  Stack,
  VStack,
  HStack,
  Text,
  Input,
  Button,
  Checkbox,
  ScrollView,
  Pressable,
  CloseIcon,
  SearchIcon,
} from "native-base";
import { Dimensions } from "react-native";
import { useNavigate } from "react-router-dom";
import { RootStateOrAny, useSelector, useDispatch } from "react-redux";
import { Loc } from "../../App/Loc";
import _ from "lodash";
import { CrossIcon } from "../../assets/icons/icon-assets";
import AVInputtext from "../../components/AVInputtext";
import AVDropdown from "../../components/AVDropdown";
import { components } from "react-select";
import { Server } from "../../Platform/Server";
import Dropdown from "../../assets/images/dropdown.svg";
import AVDatePicker from "../../components/common/AVDatePicker";
import AVTimePicker from "../../components/common/AVTimePicker";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Moment from "moment";
import dayjs, { Dayjs } from "dayjs";
import * as AV from "../../AVCore/AVCore";
import AVLocationBox from "../common/AVLocationBox";
import CustomToast from "../../Hooks/useCustomToast";
import AddandEditLinks from "./AddandEditLinks";
import { findWindows } from "windows-iana";
import * as AVI from "../../AVCore/Interfaces/AV.Interfaces";
import EntityProfilePic from "../common/EntityProfilePic";
import { setUser, setEntitydata } from "../../Redux/Actions/userActions";

type ExtendedEntity = AV.IAVEntity & {
  subType?: string;
  childOrgs?: AV.ILink[];
  staff?: AV.IStaff[];
  activity?: string;
  teams?: AV.ITypeLink[];
};

type EntityPayload = (AVI.IEvent | AVI.IGame) & {
  subType?: string;
};

interface DropdownOption {
  value: string;
  labelTeam: string;
  labelSeason: string;
}

interface Props {
  entityType?: string;
  onClose: () => void;
  isMyEvents?: boolean;
  entity?: ExtendedEntity;
  selectedDate?: Date | null;
  setSelectedDate?: (date: Date) => void;
  selectedStartTime?: Date | null;
  selectedEndTime?: Date | null;
  isDateWiseCreate?: boolean;
  setIsDateWiseCreate?: (val: boolean) => void;
  setEntity?: Dispatch<SetStateAction<AV.IAVEntity | undefined>>;
}

const AVCreateEvent: FC<Props> = ({
  entity,
  onClose,
  setEntity,
  entityType,
  isMyEvents,
  selectedDate,
  setSelectedDate,
  selectedStartTime,
  selectedEndTime,
  isDateWiseCreate,
  setIsDateWiseCreate,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dimensions = Dimensions.get("window");
  const isScreen = dimensions?.width <= 1000;
  const isMobile = dimensions?.width <= 600;

  const currentUser = useSelector(
    (state: RootStateOrAny) => state.user.user[0],
  );
  const entityDataList = useSelector(
    (state: RootStateOrAny) => state.user.entitydatalist,
  );

  /* ================= STATE ================= */
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [isAPICall, setIsAPICall] = useState(false);

  const [refreshKey, setRefreshKey] = useState(0);
  const [refreshTimeKey, setRefreshTimeKey] = useState(0);

  //const CurrentDateTime = new Date();
  //CurrentDateTime.setMinutes(0);
  //CurrentDateTime.setSeconds(0);
  //CurrentDateTime.setMilliseconds(0);
  //CurrentDateTime.setHours(CurrentDateTime.getHours() + 1);
  //let endDateTime = new Date(CurrentDateTime);
  //endDateTime.setHours(endDateTime.getHours() + 1);
  //const [startTime, setStartTime] = useState<Date | null>(CurrentDateTime);
  //const [endTime, setEndTime] = useState<Date | null>(endDateTime);

  //const adjustedTime = CurrentDateTime.toLocaleTimeString([], {
  //  hour: "numeric",
  //  minute: "numeric",
  //  hour12: true,
  //});
  //const [startingTime, setStartingTime] = useState(adjustedTime);

  //let newEndingTime = endDateTime.toLocaleTimeString([], {
  //  hour: "numeric",
  //  minute: "numeric",
  //  hour12: true,
  //});
  //const [endingTime, setEndingTime] = useState(newEndingTime);

  //const year = CurrentDateTime.getFullYear();
  //const month = (CurrentDateTime.getMonth() + 1).toString().padStart(2, "0");
  //const day = CurrentDateTime.getDate().toString().padStart(2, "0");
  //const defaultDate = `${year}-${month}-${day}`;
  //const [startDate, setStartDate] = useState<Date | null>(defaultDate);
  //const [endDate, setEndDate] = useState<Date | null>(defaultDate);

  const now = new Date();
  // Start time = next hour
  const start = new Date(now);
  start.setMinutes(0, 0, 0);
  start.setHours(start.getHours() + 1);

  // End time = +1 hour
  const end = new Date(start);
  end.setHours(end.getHours() + 1);

  // Date (midnight)
  const defaultDate = new Date(start);
  defaultDate.setHours(0, 0, 0, 0);

  const [startTime, setStartTime] = useState<Date | null>(
    isDateWiseCreate ? (selectedStartTime ?? start) : start,
  );
  const [endTime, setEndTime] = useState<Date | null>(
    isDateWiseCreate ? (selectedEndTime ?? end) : end,
  );
  const [startDate, setStartDate] = useState<Date | null>(defaultDate);
  const [endDate, setEndDate] = useState<Date | null>(defaultDate);

  // UI display (optional)
  const [startingTime, setStartingTime] = useState(
    start.toLocaleTimeString([], {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    }),
  );

  const [endingTime, setEndingTime] = useState(
    end.toLocaleTimeString([], {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    }),
  );

  const [triggerEndDate, setTriggerEndDate] = useState(false);
  const [triggerStartTime, setTriggerStartTime] = useState(false);

  const [teamArrivalTime, setTeamArrivalTime] = useState<Date | null>(null);
  const [teamArrivalDate, setTeamArrivalDate] = useState<Date | null>(null);

  const [isOtherTeamOne, setIsOtherTeamOne] = useState(false);
  const [isOtherTeamTwo, setIsOtherTeamTwo] = useState(false);
  const [otherTeamOneName, setOtherTeamOneName] = useState("");
  const [otherTeamTwoName, setOtherTeamTwoName] = useState("");
  const [teamOne, setTeamOne] = useState<string>("");
  const [teamTwo, setTeamTwo] = useState<string>("");
  const [teamOneList, setTeamOneList] = useState<DropdownOption[]>([]);
  const [teamTwoList, setTeamTwoList] = useState<DropdownOption[]>([]);
  const [allTeamSeasonList, setAllTeamSeasonList] = useState<AV.ILink[]>([]);

  const [scoreManager, setScoreManager] = useState<AV.ILink | null>(null);
  const [scoreManagerList, setScoreManagerList] = useState<AV.ILink[]>([]);

  const [url, setUrl] = useState("");
  const [addLink, setAddLink] = useState(false);
  const [linkList, setLinksList] = useState<any>([]);
  const [addLinkPopup, setAddLinkPopup] = useState(false);
  const isValidLink = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;

  const [eventLocation, setEventLocation] = useState<any>("");
  const [locationAddress, setLocationAddress] = useState<any>([]);
  const [visiblefield, setVisibleField] = useState(true);

  const [locationEntity, setLocationEntity] = useState<any>("");
  const [isFieldsName, setIsFieldsName] = useState("");
  const [siteField, setSiteField] = useState<any>();
  const [mapField, setIsMapField] = useState("");

  const [clickedUrl, setClickedUrl] = useState("");
  const [showConfirmLinkPopup, setShowConfirmLinkPopup] = useState(false);

  const [isWeek, setIsWeek] = useState(false);
  const [repeatWeek, setRepeatWeek] = useState(false);
  const [repeat, setRepeat] = useState("Does not Repeat");
  let reoccurance = useState([false, false, false, false, false, false, false]);

  const [isFocused, setIsFocused] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState<AV.ILink[]>([]);
  const [selectedEntity, setSelectedEntity] = useState<AV.ILink | null>(null);
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  const getBaseList = async () => {
    let filteredOrgs =
      currentUser?.orgs?.filter(
        (org) =>
          org?.type !== "Person" &&
          org?.type !== "Channel" &&
          org?.subType !== "Alumni" &&
          (org?.linkType === "Staff" || org?.linkType === "Owner"),
      ) || [];

    const gradClassList = filteredOrgs.filter(
      (org) => org.type === "PlayerOrg" && org.subType === "GradClass",
    );

    const removeIds: string[] = [];

    for (const org of gradClassList) {
      let evtEntity = entityDataList?.find((x) => x?.id === org?.id) ?? null;

      if (!evtEntity) {
        const evtEntityAPI: AV.IAVEntity | null = await AV.AVEntity.get(org);

        if (evtEntityAPI) {
          entityDataList?.push(evtEntityAPI);
          dispatch(setEntitydata(entityDataList));
          evtEntity = evtEntityAPI;
        }
      }

      if (
        evtEntity?.parent?.type === "School" ||
        evtEntity?.parent?.type === "Alumni"
      ) {
        removeIds.push(org.id);
      }
    }

    filteredOrgs = filteredOrgs.filter((org) => !removeIds.includes(org.id));

    return [currentUserData, ...filteredOrgs];
  };

  const [profile, setProfile] = useState<AV.IProfile>({
    background: undefined,
    pic: undefined,
    text: "",
    color: "",
  });

  const currentUserData = {
    title: currentUser?.name,
    id: currentUser?.id,
    pk: currentUser?.pk,
    region: currentUser?.region,
    type: currentUser?.type,
  };

  const handleSearchItems = async (value: string) => {
    setSearchQuery(value);

    const baseList = await getBaseList();

    if (value.trim().length > 0) {
      const filtered = baseList.filter((item) =>
        item?.title?.toLowerCase().includes(value.toLowerCase()),
      );

      setSearchResults(filtered);
    } else {
      setSearchResults(baseList); // restore default
    }
  };

  const handleEntitySelect = (entity: any) => {
    setSelectedEntity(entity);
    setIsFocused(false);
    setSearchQuery("");
  };

  const clearSearch = async () => {
    setSelectedEntity(null);
    setSearchQuery("");
    setSearchResults(await getBaseList());
    setIsFocused(true);
  };

  const handleRepeat = (event) => {
    const selectedValue = event.target.value;
    setRepeat(selectedValue);
    setRepeatWeek(selectedValue);
    if (selectedValue === "Repeat") {
      setIsWeek(true);
    } else {
      setIsWeek(false);
    }
  };

  const handleReoccurance = async (index) => {
    reoccurance[0][index] === false
      ? (reoccurance[0][index] = true)
      : (reoccurance[0][index] = false);
  };

  const handleUpdateLocationField = (e, siteField) => {
    setIsMapField(e?.name);
    setIsFieldsName(siteField?.find((x: any) => x?.name == e));
  };

  const handleStartDate = (value: Dayjs | null) => {
    if (!value) {
      setStartDate(null);
      return;
    }

    const date = value.toDate();

    if (isNaN(date.getTime())) {
      setStartDate(null);
      return;
    }

    // Century validation
    const currentYear = new Date().getFullYear();
    const startCentury = Math.floor(currentYear / 100) * 100;
    const endCentury = startCentury + 99;

    const year = date.getFullYear();
    if (year < startCentury || year > endCentury) {
      let clientError = {
        message: `Select valid year (${startCentury}-${endCentury})`,
      };
      //CustomToast({ clientError });
      setStartDate(null);
      return;
    }

    setStartDate(date);

    // Auto-fix endDate
    if (endDate && dayjs(date).isAfter(endDate)) {
      setEndDate(date);
      const timer = setTimeout(() => {
        setTriggerEndDate(!triggerEndDate);
      }, 2000);
    }
  };

  const handleEndDate = (value: Dayjs | null) => {
    if (!value) {
      setEndDate(null);
      return;
    }

    const date = value.toDate();

    if (isNaN(date.getTime())) {
      setEndDate(null);
      return;
    }

    const currentYear = new Date().getFullYear();
    const startCentury = Math.floor(currentYear / 100) * 100;
    const endCentury = startCentury + 99;

    const year = date.getFullYear();
    if (year < startCentury || year > endCentury) {
      let clientError = {
        message: `Select valid year (${startCentury}-${endCentury})`,
      };
      //CustomToast({ clientError });
      setEndDate(null);
      return;
    }

    // Prevent invalid range
    if (startDate && dayjs(date).isBefore(startDate)) {
      let clientError = { message: "End date cannot be before start date" };
      //CustomToast({ clientError });
      return;
    }

    setEndDate(date);
  };

  const correctTimeFormat = (timeString: any) => {
    const time = timeString.toLowerCase();
    const timeRegex = /^(\d{1,2}):(\d{2}) ([ap]m)$/;
    const match = time.match(timeRegex);

    if (match) {
      let hour = parseInt(match[1], 10);
      const minute = match[2];
      const period = match[3].toUpperCase(); // Convert "am/pm" to uppercase

      if (period === "PM" && hour !== 12) {
        hour += 12;
      } else if (period === "AM" && hour === 12) {
        hour = 0;
      }

      const formattedTime = `${hour.toString().padStart(2, "0")}:${minute}`;
      return formattedTime;
    }
    return timeString;
  };

  const handleStartTime = async (e) => {
    handlechange(e);

    const myDate: any = new Date(e);
    if (myDate.toString() === "Invalid Date" || isNaN(myDate) || e == null) {
      setStartTime(null);
      return;
    }
    const timeString = myDate.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });

    let val = await correctTimeFormat(timeString);
    const [hours, minutes] = val.split(":").map(Number);
    let newdate = startDate;
    newdate?.setHours(hours);
    newdate?.setMinutes(minutes);
    setStartTime(newdate);

    if (startDate === endDate) {
      handleChangeTriggerEnd(hours, minutes, newdate, startDate);
    }
  };

  const handleChangeTriggerEnd = (hours, minutes, newdate, eventStartDate) => {
    const newdatePlusOneHourClone = new Date(eventStartDate);
    newdatePlusOneHourClone.setHours(hours);
    newdatePlusOneHourClone.setMinutes(minutes);
    newdatePlusOneHourClone.setHours(newdatePlusOneHourClone.getHours() + 1);
    setEndTime(newdatePlusOneHourClone);
    if (endTime && newdate >= endTime) {
      setTriggerStartTime(!triggerStartTime);
    }

    handleChangeEnd(newdatePlusOneHourClone);
  };

  const handlechange = (e) => {
    const myDate: any = new Date(e);
    if (myDate.toString() === "Invalid Date" || isNaN(myDate) || e == null) {
      return;
    }

    const currentHour = myDate.getHours();
    const newDate = new Date(myDate);
    newDate.setHours(currentHour);
    const timeString = newDate.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });

    setStartingTime(timeString);
  };

  const handleEndTime = async (e) => {
    const myDate: any = new Date(e);
    if (myDate.toString() === "Invalid Date" || isNaN(myDate) || e == null) {
      setEndTime(null);
      setEndingTime("");
      return;
    }

    handleChangeEnd(e);

    const timeString = myDate.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });

    let val = await correctTimeFormat(timeString);
    const [hours, minutes] = val.split(":").map(Number);
    let newdate = endDate;
    newdate?.setHours(hours);
    newdate?.setMinutes(minutes);
    setEndTime(newdate);
  };

  const handleChangeEnd = (e) => {
    const myDate: any = new Date(e);
    if (myDate.toString() === "Invalid Date" || isNaN(myDate) || e == null) {
      setEndTime(null);
      setEndingTime("");
      return;
    }

    const currentHour = myDate.getHours();
    const newDate = new Date(myDate);
    newDate.setHours(currentHour);
    const timeString = newDate.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
    setEndingTime(timeString);
  };

  const handleTeamArrivalTime = async (e) => {
    //handlechange(e);

    const myDate: any = new Date(e);
    if (myDate.toString() === "Invalid Date" || isNaN(myDate) || e == null) {
      setTeamArrivalTime(null);
      return;
    }
    const timeString = myDate.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });

    let val = await correctTimeFormat(timeString);
    const [hours, minutes] = val.split(":").map(Number);
    let newdate = startDate;
    newdate?.setHours(hours);
    newdate?.setMinutes(minutes);
    setTeamArrivalTime(newdate);
  };

  const handleTeamArrivalDate = (value: Dayjs | null) => {
    if (!value) {
      setTeamArrivalDate(null);
      return;
    }

    const date = value.toDate();

    if (isNaN(date.getTime())) {
      setTeamArrivalDate(null);
      return;
    }

    // Century validation
    const currentYear = new Date().getFullYear();
    const startCentury = Math.floor(currentYear / 100) * 100;
    const endCentury = startCentury + 99;

    const year = date.getFullYear();
    if (year < startCentury || year > endCentury) {
      let clientError = {
        message: `Select valid year (${startCentury}-${endCentury})`,
      };
      //CustomToast({ clientError });
      setTeamArrivalDate(null);
      return;
    }

    setTeamArrivalDate(date);
  };

  const handleSelectTeamOne = (e) => {
    const value = e.target.value;
    setTeamOne(value);

    if (value === "others") {
      setIsOtherTeamOne(true);
    } else {
      setIsOtherTeamOne(false);
    }
  };

  const handleSelectTeamTwo = (e) => {
    const value = e.target.value;
    setTeamTwo(value);

    if (value === "others") {
      setIsOtherTeamTwo(true);
    } else {
      setIsOtherTeamTwo(false);
    }
  };

  const handleScoreManger = (e) => {
    setScoreManager(e.target.value);
  };

  const handleCreate = async () => {
    let windowsTimeZone;
    const showError = (msg) => CustomToast({ clientError: { message: msg } });

    // ================= VALIDATIONS =================
    if (addLink && url) {
      if (!isValidLink.test(url)) {
        return showError(Loc.currentLang.menu.invalidLink);
      }

      const ianaTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      windowsTimeZone = findWindows(ianaTimeZone);
    }

    if (
      startDate &&
      endDate &&
      (startDate < defaultDate || endDate < defaultDate)
    ) {
      return showError(Loc.currentLang.menu.invalidDate);
    }

    if (startDate && endDate && (startDate > endDate || endDate < startDate)) {
      return showError(Loc.currentLang.menu.invalidDate);
    }

    // Max 6 months
    const maxEnd = dayjs(startDate).add(6, "month");
    if (dayjs(endDate).isAfter(maxEnd)) {
      return showError(Loc.currentLang.menu?.endDateLimit);
    }

    // Time
    if (startDate === endDate && startDate === defaultDate) {
      const currentDateTimes = new Date();
      const eventStartTimeOnly = Moment(startTime).format("HH:mm:ss");
      const eventStartDateTimes = startTime;
      if (eventStartDateTimes && eventStartDateTimes < currentDateTimes) {
        return showError(Loc.currentLang.menu.invalidStartTime);
      }

      // Check if event end date is in the past
      const eventEndTimeOnly = Moment(endTime).format("HH:mm:ss");
      const eventEndDateTimes = endTime;
      if (eventEndDateTimes && eventEndDateTimes < currentDateTimes) {
        return showError(Loc.currentLang.menu.invalidEndTime);
      }

      // Check if event start time is after event end time
      if (eventStartTimeOnly > eventEndTimeOnly) {
        return showError(Loc.currentLang.menu.startTimeAfterEnd);
      }

      if (eventStartTimeOnly === eventEndTimeOnly) {
        return showError(Loc.currentLang.menu.sameStartAndEndTime);
      }
    }

    if (
      startDate &&
      endDate &&
      startDate === defaultDate &&
      endDate > startDate
    ) {
      const currentDateTimes = new Date();
      const eventStartDateTimes = startTime;
      if (eventStartDateTimes && eventStartDateTimes < currentDateTimes) {
        return showError(Loc.currentLang.menu.startInThePast);
      }
    }

    if (isWeek) {
      const hasDay = reoccurance[0].some((d) => d === true);
      if (!hasDay) {
        return showError(Loc.currentLang.menu?.repeatMinOneDay);
      }
    }

    //const fullStartDateTime = Moment(
    //  `${startDate} ${startTime}`,
    //  "MM/DD/YYYY hh:mm A",
    //).toDate();
    //
    //const fullEndDateTime = Moment(
    //  `${endDate} ${endTime}`,
    //  "MM/DD/YYYY hh:mm A",
    //).toDate();
    //
    //if (fullStartDateTime >= fullEndDateTime) {
    //  return showError(Loc.currentLang.menu?.invalidStartTime);
    //}

    if (entityType === "Game") {
      if (startDate && teamArrivalDate) {
        const arrivalDate = new Date(teamArrivalDate).toDateString();
        const start = new Date(startDate).toDateString();

        // Date mismatch check
        if (arrivalDate !== start) {
          return showError(Loc.currentLang.menu?.arrivalDateMismatch);
        }
      }

      // Time check
      if (teamArrivalDate && teamArrivalTime && startDate && startingTime) {
        const arrival = Moment(teamArrivalDate)
          .hour(Moment(teamArrivalTime).hour())
          .minute(Moment(teamArrivalTime).minute())
          .second(0)
          .millisecond(0);

        const start = Moment(startDate)
          .hour(Moment(startingTime, ["h:mm A", "HH:mm"]).hour())
          .minute(Moment(startingTime, ["h:mm A", "HH:mm"]).minute())
          .second(0)
          .millisecond(0);

        console.log("Arrival:", arrival.format("YYYY-MM-DD HH:mm:ss"));
        console.log("Start   :", start.format("YYYY-MM-DD HH:mm:ss"));

        if (arrival.isSameOrAfter(start)) {
          return showError(Loc.currentLang.menu?.arrivalAfterStart);
        }
      }
    }

    // ================= MERGE DATE + TIME =================

    const eventStartDateTime = Moment(startDate)
      .hour(Moment(startingTime, ["HH:mm", "h:mm A"]).hour())
      .minute(Moment(startingTime, ["HH:mm", "h:mm A"]).minute())
      .second(0)
      .millisecond(0)
      .toDate();

    const eventEndDateTime = Moment(startDate)
      .hour(Moment(endingTime, ["HH:mm", "h:mm A"]).hour())
      .minute(Moment(endingTime, ["HH:mm", "h:mm A"]).minute())
      .second(0)
      .millisecond(0)
      .toDate();

    const reoccurEndDateTime = Moment(endDate)
      .hour(Moment(endingTime, ["HH:mm", "h:mm A"]).hour())
      .minute(Moment(endingTime, ["HH:mm", "h:mm A"]).minute())
      .second(0)
      .millisecond(0)
      .toDate();

    const teamArrivalDateTime = Moment(teamArrivalDate)
      .hour(Moment(teamArrivalTime, ["HH:mm", "h:mm A"]).hour())
      .minute(Moment(teamArrivalTime, ["HH:mm", "h:mm A"]).minute())
      .second(0)
      .millisecond(0)
      .toDate();

    // ================= LOCATION =================

    let locationOfField = {
      ...locationAddress,
      field: isFieldsName || {},
      siteMap: locationEntity?.siteMap ?? {},
    };

    // ================= SCORETYPE =================

    let scoreType = entity?.activity ?? "";
    if (
      (entityType === "Game" || entityType === "LeagueGame") &&
      scoreType === ""
    ) {
      if (!entity) return; // or handle appropriately

      let parentEntity =
        entityDataList?.find(
          (x) =>
            x?.id === (entityType === "Game" ? entity.parent?.id : entity.id),
        ) ?? null;

      if (!parentEntity) {
        const parentFk =
          entityType === "Game" ? entity.parent : AV.AVEntity.getFk(entity);

        if (parentFk) {
          const parentEntityAPI = await AV.AVEntity.get(parentFk);

          if (parentEntityAPI) {
            entityDataList?.push(parentEntityAPI);
            dispatch(setEntitydata(entityDataList));
            parentEntity = parentEntityAPI;
          }
        }
      }

      scoreType = parentEntity?.activity ?? "";
    }

    // ================= EVENT OBJECT =================
    const buildTeamPayload = (team, otherName): AV.ITypeLink | null => {
      if (team === "others") {
        const id = Server.generateUUID();

        return {
          id,
          pk: id.slice(-4),
          region: entity?.region,
          title: otherName.trim(),
          data: otherName.trim(),
          type: "PlayerOrg",
          subType: "Softlink",
        };
      }

      if (team) {
        return allTeamSeasonList?.find((x) => x.id === team) ?? null;
      }
      return null;
    };

    let teamsPayload: AV.ITypeLink[] = [];

    if (entityType === "LeagueGame") {
      teamsPayload = [
        buildTeamPayload(teamOne, otherTeamOneName),
        buildTeamPayload(teamTwo, otherTeamTwoName),
      ].filter((x): x is AV.ITypeLink => Boolean(x));
    }

    let entityPayload: EntityPayload;

    entityPayload = {
      type: entityType === "Game" ? entityType : "Event",
      name: title,
      eventType: entityType === "Game" ? entityType : "Meeting",
      start: eventStartDateTime,
      end: eventEndDateTime,
      profile: profile,
      playerStart: entityType === "Game" ? teamArrivalDateTime : null,
      parent: selectedEntity
        ? AV.AVEntity.getFk({
            ...selectedEntity,
            status: selectedEntity.status ?? undefined,
          } as AV.IAVEntity)
        : undefined,
      scoreType: scoreType,
      reoccurance: isWeek
        ? {
            type: "Weekly",
            days: reoccurance[0],
            startDate: eventStartDateTime,
            endDate: reoccurEndDateTime,
          }
        : undefined,

      location: addLink ? null : locationOfField,
      locURL: url || undefined,
      tz: url ? (windowsTimeZone?.toLocaleString() ?? null) : null,
      links: linkList,

      preferences: {
        isPrivate: false,
      } as AV.IPreferences,
    };

    if (entityType === "LeagueGame") {
      entityPayload.eventType = "";
      entityPayload.subType = undefined;
      entityPayload.teams = teamsPayload;
      entityPayload.type = "LeagueGameBase";

      //scoreManager: scoreManager
      //  ? AV.AVEntity.getFk({
      //      ...scoreManager,
      //      status: scoreManager.status ?? undefined,
      //    } as AV.IAVEntity)
      //  : undefined,
    }

    // ================= API =================

    try {
      setIsAPICall(true);
      console.log("entityPayload", entityPayload);
      const eventData = await AV.AVEntity.save(entityPayload);

      if (eventData) {
        // Create Selected Team Game Event
        if (entityType === "LeagueGame") {
          await createTeamGameEvents(eventData as AVI.IGame);
        }

        let finalUser = await AV.Person.getSelf(true);
        dispatch(setUser(finalUser));

        let index = entityDataList?.findIndex((x) => x?.id === finalUser?.id);
        if (index !== -1) {
          entityDataList[index] = finalUser;
          dispatch(setEntitydata(entityDataList));
        }

        let newSeriesId = "undefined";
        if (
          eventData &&
          "eventType" in eventData &&
          (eventData.eventType === "Meeting" ||
            eventData.eventType === "Practice")
        ) {
          const eventWithSeries = eventData as any;

          newSeriesId =
            eventWithSeries?.seriesEvents?.length > 0
              ? eventWithSeries.seriesEvents[0].id
              : "undefined";
        }

        navigate(
          `/Events/${eventData?.id}/${eventData?.region}/${newSeriesId}`,
          {
            state: { team: eventData, newEntity: true },
          },
        );
      }
    } catch (error) {
      console.error("Error saving event:", error);
      setIsAPICall(false);
      //showError("Failed to create event");
    }
  };

  const createTeamGameEvents = async (leagueGame: AVI.IGame) => {
    try {
      const teams = leagueGame.teams ?? [];

      for (const team of teams) {
        if (team?.subType === "Softlink") continue;

        const teamGamePayload: AVI.IGame = {
          type: "Game",
          eventType: "Game",
          name: leagueGame.name,
          start: leagueGame.start,
          end: leagueGame.end,
          playerStart: leagueGame.playerStart,
          //teams: teams,
          parent: team,
          topParent: leagueGame.parent,
          scoreType: leagueGame.scoreType,
          location: leagueGame.location,
          locURL: leagueGame.locURL,
          tz: leagueGame.tz,
          links: leagueGame.links,
          league: AV.AVEntity.getLink(entity!),
          leagueGame: AV.AVEntity.getFk(leagueGame),
          preferences: {
            isPrivate: false,
          } as AV.IPreferences,
        };

        await AV.AVEntity.save(teamGamePayload);
      }
    } catch (error) {
      console.error("Error creating team game events:", error);
    }
  };

  const isCreateDisabled = () => {
    if (!title?.trim()) return true;
    if (!selectedEntity) return true;
    if (!startDate || !endDate) return true;
    if (!startTime || !endTime) return true;

    if (
      entity?.type === "LeagueSeason" &&
      teamOne !== "others" &&
      teamTwo !== "others" &&
      (!teamOne?.trim() || !teamTwo?.trim())
    )
      return true;

    if (
      entity?.type === "LeagueSeason" &&
      teamOne === "others" &&
      !otherTeamOneName?.trim()
    )
      return true;

    if (
      entity?.type === "LeagueSeason" &&
      teamTwo === "others" &&
      !otherTeamTwoName?.trim()
    )
      return true;

    //if (entityType === "Game" && (!teamArrivalDate || !teamArrivalTime))
    //  return true;

    if (addLink) {
      if (!url?.trim()) return true;
    } else {
      if (!locationAddress?.id) return true;
    }

    return false;
  };

  useEffect(() => {
    setRefreshKey((prevKey) => prevKey + 1);
  }, [triggerEndDate]);

  useEffect(() => {
    setRefreshTimeKey((prevKey) => prevKey + 1);
  }, [triggerStartTime]);

  useEffect(() => {
    if (isDateWiseCreate && selectedDate) {
      setStartDate(selectedDate);
      setEndDate(selectedDate);
    }
  }, [selectedDate, isDateWiseCreate]);

  useEffect(() => {
    const loadData = async () => {
      if (isMyEvents) {
        const list = await getBaseList();
        setSearchResults(list);
      } else {
        clearSearch();
        setSelectedEntity(AV.AVEntity.getLink(entity ?? currentUser));

        const allTeamSeasons: AV.ILink[] = [];
        let teamOptions: DropdownOption[] = [];
        const playerOrgs: AV.ILink[] =
          entity?.childOrgs?.filter(
            (x) => x?.type === "PlayerOrg" && x?.subType !== "Softlink",
          ) || [];
        const softLink =
          entity?.childOrgs?.filter((x) => x?.subType === "Softlink") || [];

        if (playerOrgs) {
          allTeamSeasons.push(...playerOrgs);

          playerOrgs.forEach((x) => {
            teamOptions.push({
              value: x.id ?? "",
              labelTeam: x.title ?? "",
              labelSeason: x.data ?? x.title ?? "",
            });
          });
        }

        if (softLink) {
          allTeamSeasons.push(...softLink);

          softLink.forEach((x) => {
            teamOptions.push({
              value: x.id ?? "",
              labelTeam: x.title ?? "",
              labelSeason: x.data ?? x.title ?? "",
            });
          });
        }

        //teamOptions.push({
        //  value: "others",
        //  labelTeam: "Others",
        //  labelSeason: "Others",
        //});

        setTeamOneList(teamOptions);
        setTeamTwoList(teamOptions);
        setAllTeamSeasonList(allTeamSeasons);
        setScoreManagerList(entity?.staff ?? []);
      }
    };

    loadData();
  }, [isMyEvents, currentUser]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setIsFocused(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <img src={Dropdown} alt="Dropdown" style={{ width: "25px" }} />
      </components.DropdownIndicator>
    );
  };

  return (
    <Box
      position="fixed"
      bgColor="rgba(0, 0, 0, 0.25)"
      bottom={0}
      right={0}
      top={0}
      left={0}
      height="100%"
      width="100%"
    >
      {/* ================= MODAL ================= */}
      <div
        style={{
          position: "fixed",
          top: "56%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          background: "#ffffff",
          boxShadow:
            "0 12px 28px 0 rgba(0,0,0,0.2), 0 2px 4px 0 rgba(0,0,0,0.1)",
          width: isMobile ? "88%" : "580px",
          borderRadius: "8px",
          height: "88%",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <VStack flex={1}>
          {/* ================= HEADER ================= */}
          <HStack
            alignItems="center"
            marginX="24px"
            marginTop="24px"
            justifyContent="space-between"
          >
            <Text fontSize="24px">
              {entityType === "Game"
                ? Loc.currentLang.menu.create +
                  " " +
                  Loc.currentLang.menu.gamesTxt
                : entityType === "LeagueGame"
                  ? Loc.currentLang.menu.create +
                    Loc.currentLang.menu.leagueGame
                  : Loc.currentLang.menu.create +
                    " " +
                    Loc.currentLang.menu.event}
            </Text>

            <Pressable
              onPress={() => {
                setIsDateWiseCreate?.(false);

                //const today = dayjs().startOf("day");
                //const selected = selectedDate
                //  ? dayjs(selectedDate).startOf("day")
                //  : null;

                //const isPastDate = selected ? selected.isBefore(today) : false;

                //let newDate;

                //if (isPastDate) {
                //  newDate = defaultDate;
                //} else if (selected && dayjs(defaultDate).isBefore(selected)) {
                //  newDate = defaultDate;
                //} else {
                //  newDate = selectedDate ?? new Date();
                //}

                //setSelectedDate?.(newDate);

                onClose();
              }}
              _hover={{ bgColor: "AVColor.grey", borderRadius: "sm" }}
              rounded="full"
              borderBottomColor="AVColor.grey"
              px={-1}
            >
              <CrossIcon size="30px" color="#000000" alignSelf="center" />
            </Pressable>
          </HStack>

          {/* ================= BODY ================= */}
          <VStack
            flex={1}
            overflow="auto"
            px="24px"
            mb="60px"
            mt={repeatWeek ? "30px" : "20px"}
            space="18px"
          >
            {/* ================= SEARCH / SELECTED ================= */}
            {isMyEvents && (
              <Box position="relative" zIndex={1000} ref={wrapperRef}>
                {!selectedEntity ? (
                  <>
                    {/* ================= INPUT ================= */}
                    <Input
                      placeholder={Loc.currentLang.menu.entityReq}
                      value={searchQuery}
                      onChangeText={handleSearchItems}
                      onFocus={() => setIsFocused(true)}
                      size="lg"
                      borderRadius="md"
                      borderColor="gray.400"
                      _focus={{
                        bg: "white",
                        borderColor: "gray.400",
                        focusOutlineColor: "gray.200",
                      }}
                      _hover={{
                        bg: "white",
                        borderColor: "gray.400",
                        focusOutlineColor: "gray.200",
                      }}
                      InputRightElement={<SearchIcon mr="2" />}
                    />

                    {/* ================= DROPDOWN ================= */}
                    {isFocused && (
                      <Box
                        position="absolute"
                        top="100%"
                        left={0}
                        right={0}
                        bg="white"
                        borderRadius="8px"
                        shadow={5}
                        zIndex={9999}
                        maxH="300px"
                        overflow="auto"
                      >
                        {searchResults.length > 0 ? (
                          searchResults.map((item) => (
                            <Pressable
                              key={item.id}
                              onPress={() => handleEntitySelect(item)}
                              p={3}
                              _hover={{ bg: "gray.50" }}
                            >
                              <HStack space={3} alignItems="center">
                                <Box
                                  width={8}
                                  height={8}
                                  borderRadius="full"
                                  overflow="hidden"
                                  bg="gray.100"
                                  alignItems="center"
                                  justifyContent="center"
                                >
                                  <EntityProfilePic
                                    width="32px"
                                    height="32px"
                                    link={
                                      currentUser?.id === item?.id
                                        ? AV.AVEntity.getLink(currentUser)
                                        : entityDataList?.find(
                                              (x: any) => x?.id === item?.id,
                                            )
                                          ? AV.AVEntity.getLink(
                                              entityDataList.find(
                                                (x: any) => x?.id === item?.id,
                                              ),
                                            )
                                          : item
                                    }
                                  />
                                </Box>

                                <Text fontWeight="medium">
                                  {item?.title ?? ""}
                                </Text>
                              </HStack>
                            </Pressable>
                          ))
                        ) : (
                          <Box p={4} alignItems="center">
                            <Text fontSize="sm" color="gray.500">
                              {Loc.currentLang.menu.noRecordsFound}
                            </Text>
                          </Box>
                        )}
                      </Box>
                    )}
                  </>
                ) : (
                  /* ================= SELECTED CHIP ================= */
                  <HStack
                    alignItems="center"
                    bg="#F1F1F1"
                    borderRadius="full"
                    px={3}
                    py={2}
                    width="fit-content"
                    space={2}
                  >
                    <Box
                      width={8}
                      height={8}
                      borderRadius="full"
                      overflow="hidden"
                      bg="gray.200"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <EntityProfilePic
                        width="32px"
                        height="32px"
                        link={
                          currentUser?.id === selectedEntity?.id
                            ? AV.AVEntity.getLink(currentUser)
                            : entityDataList?.find(
                                  (x: any) => x?.id === selectedEntity?.id,
                                )
                              ? AV.AVEntity.getLink(
                                  entityDataList.find(
                                    (x: any) => x?.id === selectedEntity?.id,
                                  ),
                                )
                              : selectedEntity
                        }
                      />
                    </Box>

                    <Text fontSize="sm" fontWeight="medium">
                      {selectedEntity?.title}
                    </Text>

                    <Pressable onPress={clearSearch}>
                      <CloseIcon size="3" />
                    </Pressable>
                  </HStack>
                )}
              </Box>
            )}

            {/* ================= REPEAT ================= */}
            {entityType !== "Game" && entityType !== "LeagueGame" && (
              <VStack width="100%" top={!isMyEvents ? "8px" : "0px"}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    {Loc.currentLang.menu.repeatReq}
                  </InputLabel>
                  <Select value={repeat} label="Repeat" onChange={handleRepeat}>
                    <MenuItem value="Does not Repeat">
                      {Loc.currentLang.menu.doesNotRepeat}
                    </MenuItem>
                    <MenuItem value="Repeat">
                      {Loc.currentLang.menu.repeat}
                    </MenuItem>
                  </Select>
                </FormControl>

                {repeatWeek && isWeek && (
                  <VStack py={3} width="100%">
                    <HStack space="16px" flexWrap="wrap">
                      {[1, 2, 3, 4, 5, 6, 0].map((day) => (
                        <Checkbox
                          key={day}
                          value="false"
                          onChange={() => handleReoccurance(day)}
                        >
                          {
                            [
                              Loc.currentLang.calendar.mon,
                              Loc.currentLang.calendar.tue,
                              Loc.currentLang.calendar.wed,
                              Loc.currentLang.calendar.thu,
                              Loc.currentLang.calendar.fri,
                              Loc.currentLang.calendar.sat,
                              "Sun",
                            ][day === 0 ? 6 : day - 1]
                          }
                        </Checkbox>
                      ))}
                    </HStack>
                  </VStack>
                )}
              </VStack>
            )}

            {/* ================= TITLE ================= */}
            <Box
              width="100%"
              top={
                entityType === "Game" || entityType === "LeagueGame"
                  ? "5px"
                  : "0px"
              }
            >
              <AVInputtext
                type="text"
                label={
                  entityType === "Game" || entityType === "LeagueGame"
                    ? Loc.currentLang.gameEvent.gameTitleReq
                    : Loc.currentLang.menu.eventTitle
                }
                maxLength={50}
                value={title}
                onChange={(e) => setTitle(e?.target?.value ?? e)}
              />
            </Box>

            {/* ================= DATE ================= */}
            {entityType !== "Game" && entityType !== "LeagueGame" && (
              <HStack space={3} flexDirection={{ base: "column", md: "row" }}>
                <Box flex={1}>
                  <AVDatePicker
                    key={`start-date-${refreshKey}`}
                    label={Loc.currentLang.menu.startDate}
                    disable={false}
                    //disable={
                    //  isDateWiseCreate ? repeat === "Does not Repeat" : false
                    //}
                    defaultValue={startDate ? dayjs(startDate) : null}
                    onChange={(value) => handleStartDate(value)}
                  />
                </Box>

                <Box flex={1}>
                  <AVDatePicker
                    key={`end-date-${refreshKey}`}
                    label={Loc.currentLang.menu.endDate}
                    disable={false}
                    //disable={
                    //  isDateWiseCreate ? repeat === "Does not Repeat" : false
                    //}
                    defaultValue={endDate ? dayjs(endDate) : null}
                    onChange={(value) => handleEndDate(value)}
                  />
                </Box>
              </HStack>
            )}

            {(entityType === "Game" || entityType === "LeagueGame") && (
              <Box width="100%">
                <AVDatePicker
                  key={`start-date-${refreshKey}`}
                  label={Loc.currentLang.gameEvent.gameDateReq}
                  disable={false}
                  defaultValue={startDate ? dayjs(startDate) : null}
                  onChange={(value) => handleStartDate(value)}
                />
              </Box>
            )}

            {/* ================= SELECT TEAM ================= */}
            {entity?.type === "LeagueSeason" && (
              <HStack space={3} flexDirection={{ base: "column", md: "row" }}>
                {/* TEAM ONE */}
                <Box flex={1}>
                  <AVDropdown
                    value={teamOne}
                    onChange={handleSelectTeamOne}
                    options={teamOneList?.filter(
                      (opt) => opt.value === "others" || opt.value !== teamTwo,
                    )}
                    label={Loc.currentLang.gameEvent.teamA}
                  />

                  {isOtherTeamOne && (
                    <Box mt={2}>
                      <AVInputtext
                        type="text"
                        label={Loc.currentLang.gameEvent.enterTeamA}
                        maxLength={100}
                        value={otherTeamOneName}
                        onChange={(e) => setOtherTeamOneName(e.target.value)}
                      />
                    </Box>
                  )}
                </Box>

                {/* TEAM TWO */}
                <Box flex={1}>
                  <AVDropdown
                    value={teamTwo}
                    onChange={handleSelectTeamTwo}
                    options={teamTwoList?.filter(
                      (opt) => opt.value === "others" || opt.value !== teamOne,
                    )}
                    label={Loc.currentLang.gameEvent.teamB}
                  />

                  {isOtherTeamTwo && (
                    <Box mt={2}>
                      <AVInputtext
                        type="text"
                        label={Loc.currentLang.gameEvent.enterTeamB}
                        maxLength={100}
                        value={otherTeamTwoName}
                        onChange={(e) => setOtherTeamTwoName(e.target.value)}
                      />
                    </Box>
                  )}
                </Box>
              </HStack>
            )}

            {/* ================= TIME ================= */}
            <HStack space={3} flexDirection={{ base: "column", md: "row" }}>
              <Box flex={1}>
                <AVTimePicker
                  key={`start-time-${refreshTimeKey}`}
                  label={Loc.currentLang.menu.startTime}
                  disable={false}
                  defaultValue={dayjs(startTime)}
                  onChange={(value) => handleStartTime(value)}
                />
              </Box>

              <Box flex={1}>
                <AVTimePicker
                  key={`end-time-${refreshTimeKey}`}
                  label={Loc.currentLang.menu.endTime}
                  disable={false}
                  defaultValue={dayjs(endTime)}
                  onChange={(value) => handleEndTime(value)}
                />
              </Box>
            </HStack>

            {/* ================= ARRIVAL DATE TIME ================= */}
            {entityType === "Game" && (
              <HStack space={3} flexDirection={{ base: "column", md: "row" }}>
                <Box flex={1}>
                  <AVTimePicker
                    defaultValue={null}
                    label={Loc.currentLang.menu.teamArivalTime}
                    onChange={handleTeamArrivalTime}
                    disable={false}
                  />
                </Box>

                <Box flex={1}>
                  <AVDatePicker
                    label={Loc.currentLang.menu.teamArrivalDate}
                    onChange={handleTeamArrivalDate}
                    defaultValue={null}
                    disable={false}
                  />
                </Box>
              </HStack>
            )}

            {/* ================= SCORE MANAGER ================= */}
            {/*{entity?.type === "LeagueSeason" && (*/}
            {/*  <Box width="100%">*/}
            {/*    <AVDropdown*/}
            {/*      value={scoreManager}*/}
            {/*      onChange={handleScoreManger}*/}
            {/*      options={scoreManagerList}*/}
            {/*      label={"Score Manager"}*/}
            {/*    />*/}
            {/*  </Box>*/}
            {/*)}*/}

            {/* ================= DESCRIPTION ================= */}
            <Box width={"100%"}>
              <AVInputtext
                type="text"
                multiline
                value={description}
                maxLength={250}
                onChange={(e) => {
                  const value = e?.target?.value ?? e;
                  setDescription(value);
                  setProfile((profile) => ({ ...profile, text: value }));
                }}
                label={Loc.currentLang.feeCollect.description}
              />
            </Box>

            {/* ================= ONLINE ================= */}
            <Box>
              <Stack
                direction={{
                  base: "row",
                  md: "row",
                }}
                space="35px"
                alignItems="flex-start"
                zIndex={-2}
              >
                <Checkbox
                  size="sm"
                  zIndex={-2}
                  isChecked={addLink}
                  onChange={() => {
                    setAddLink(!addLink);
                    setUrl("");
                    setEventLocation("");
                    setLocationAddress([]);
                    setVisibleField(false);
                  }}
                  value={""}
                >
                  {Loc.currentLang.menu.onlineEvent}
                </Checkbox>
              </Stack>
            </Box>

            {/* ================= URL ================= */}

            {addLink && (
              <Box width="100%">
                <AVInputtext
                  type="text"
                  label={`${Loc.currentLang.menu.eventUrl} *`}
                  maxLength={500}
                  value={url}
                  onChange={(e) => setUrl(e?.target?.value ?? e)}
                />
              </Box>
            )}

            {/* ================= LOCATION ================= */}
            {!addLink && (
              <AVLocationBox
                isGame={false}
                isPractice={false}
                seriesEvent={undefined}
                setSiteField={setSiteField}
                locationaddress={locationAddress}
                setlocationaddress={setLocationAddress}
                isCreate={true}
                handleupdatelocationfield={handleUpdateLocationField}
                setEventLocation={setEventLocation}
                visiblefield={visiblefield}
                setVisibleField={setVisibleField}
                eventLocation={eventLocation}
                isShowEdit={false}
                Entity={selectedEntity}
                setLocationEntity={setLocationEntity}
                locationEntity={locationEntity}
                mapField={mapField}
                setIsMapField={setIsMapField}
                isCreateevent={true}
                isFieldsName={isFieldsName}
                setIsFieldsName={setIsFieldsName}
              />
            )}

            {/* ================= ADD LINK ================= */}
            <Box width="100%">
              <Pressable width="100%" onPress={() => setAddLinkPopup(true)}>
                <HStack>
                  <Text color="#00A7BC" fontWeight={500}>
                    +
                  </Text>
                  <Text color="#00A7BC" fontWeight={500}>
                    {Loc.currentLang.menu.addLinks}
                  </Text>
                </HStack>
              </Pressable>
            </Box>

            {addLinkPopup && (
              <Box
                position="fixed"
                top={0}
                left={0}
                right={0}
                bottom={0}
                bg="rgba(0,0,0,0.4)"
                zIndex={99999}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Box bg="white" width="400px" borderRadius="12px" p={6}>
                  <AddandEditLinks
                    setAddLinkPopup={setAddLinkPopup}
                    setLinksList={setLinksList}
                    linkList={linkList}
                    isCreate={true}
                    isCreateEvent={true}
                    setClickedUrl={setClickedUrl}
                    setShowConfirmLinkPopup={setShowConfirmLinkPopup}
                  />
                </Box>
              </Box>
            )}

            {/* ================= FOOTER ================= */}
            <HStack width="100%" justifyContent="center" space={3}>
              <Button
                width={isMobile || isScreen ? "40%" : "180px"}
                height="40px"
                bgColor="#EEEEEE"
                rounded="full"
                color="rgba(0,0,0,0.5)"
                onPress={() => {
                  setIsDateWiseCreate?.(false);
                  onClose();
                }}
              >
                <Text
                  fontSize={isMobile || isScreen ? "14px" : "18px"}
                  color="rgba(0,0,0,0.5)"
                >
                  {Loc.currentLang.menu.cancel}
                </Text>
              </Button>

              <Button
                width={isMobile || isScreen ? "40%" : "180px"}
                bgColor="#32AE78"
                height="40px"
                rounded="full"
                isLoading={isAPICall}
                isDisabled={isCreateDisabled()}
                onPress={() => handleCreate()}
              >
                <Text
                  fontSize={isMobile || isScreen ? "14px" : "18px"}
                  color="white"
                >
                  {Loc.currentLang.menu.create}
                </Text>
              </Button>
            </HStack>
          </VStack>
        </VStack>
      </div>
    </Box>
  );
};

export default AVCreateEvent;
